import Styled from "styled-components";

export const PageContainer = Styled.div`
  padding: 20px 20px 32px;
`;

export const PixCodeBox = Styled.div`
  border: 1px dashed #D2D2D7;
  border-radius: 8px;
  padding: 12px 14px;
  font-family: monospace;
  font-size: 11px;
  line-height: 1.6;
  word-break: break-all;
  color: #333;
  margin-bottom: 12px;
`;

export const OrderNumberBox = Styled.div`
  background-color: #FAFBFF;
  border-radius: 8px;
  padding: 14px 20px;
  text-align: center;
  margin: 16px 0;
`;

export const QRCodeWrapper = Styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0;
`;

export const ExpirationBadge = Styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  color: #2D8D68;
  margin-bottom: 12px;
`;

export const Separator = Styled.hr`
  border: none;
  border-top: 1px solid #E8E8E8;
  margin: 16px 0;
`;
